import TreeSelect from './src/TreeSelect.vue'

/* istanbul ignore next */
TreeSelect.install = function(Vue) {
    Vue.component(TreeSelect.name, TreeSelect)
}

export default TreeSelect
